import { useTranslation } from "react-i18next";

/**
 * Storefront loading paint.
 *
 * Deliberately NOT a fake wireframe: we don't know the courier's theme yet,
 * so guessing block geometry looks amateur and flashes the wrong palette.
 * Instead we hold the storefront's own neutral background with a quiet
 * progress line, so the real themed page swaps in without a jolt.
 */
const StorefrontSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-white"
      role="status"
      aria-label={t("storefront.common.loading")}
    >
      <div className="relative h-[2px] w-[132px] overflow-hidden bg-black/10">
        <span className="absolute inset-y-0 left-0 w-2/5 bg-[var(--color-orange,#F26419)] ec-boot-slide" />
      </div>
      <span className="sr-only">{t("storefront.common.loading")}</span>
    </div>
  );
};

export default StorefrontSkeleton;
